import { toHslaString } from 'shared/mappers'

export const donorRollStyles = (backgroundColor: ColorHsla, color: ColorHsla, fontSize: number): CSSProperties => ({
    backgroundColor: toHslaString(backgroundColor),
    color: toHslaString(color),
    fontSize: `${fontSize}px`,
})
